// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1x-0";